import React from 'react'

import { Divider } from '_zari/core'

import * as Sections from './sections'

const ResumenDiarioTab = () => {
  const filtrosFormikRef = React.useRef(null)

  const [documentos, setDocumentos] = React.useState([])

  const repetirConsultaDocumentos = React.useCallback(() => {
    if (filtrosFormikRef.current && filtrosFormikRef.current.handleSubmit) {
      filtrosFormikRef.current.handleSubmit()
    }
  }, [])

  const actualizarListaDocumentos = React.useCallback(nuevoArr => {
    setDocumentos(nuevoArr)
  }, [])

  return (
    <>
      <Sections.FiltrosSection innerRef={filtrosFormikRef} actualizarListaDocumentos={actualizarListaDocumentos} />
      <Divider noMargin />
      <Sections.ListaDocumentosSection documentos={documentos} />
      <Sections.BotonesEnvioSection documentos={documentos} repetirConsultaDocumentos={repetirConsultaDocumentos} />
    </>
  )
}

export default React.memo(ResumenDiarioTab)
